// extracted by mini-css-extract-plugin
module.exports = {"app":"zeus_solution_ability_detail2933_app__3KEcV"};